import { useImpersonation } from "@user-management-context/primary/user/impersonation/use-impersonation";
import { Button } from "@shared-kernel/primary/shared/shadcn/ui/button";
import { UserCog2 } from "lucide-react";
import { ROLES_MAP } from "@user-management-context/shared/domain/types/enums/roles";
import { useSession } from "@user-management-context/primary/hooks/use-session";
import { useAppSelector } from "@redux/hooks";
import { selectAccountRolesRetrieval } from "@user-management-context/read/application/use-cases/account-roles/selectors/account-roles-selectors";

export function ImpersonationBanner() {
  const { stopImpersonation, isImpersonating, userInfo } = useImpersonation();
  const { activeRole } = useSession();
  const { data: accountRoles } = useAppSelector(selectAccountRolesRetrieval);

  if (!isImpersonating || !userInfo || !activeRole) return null;

  // displayName is now scoped to the active role (from /accounts/roles), not the account profile.
  const displayName = accountRoles.find(r => r.role === activeRole)?.displayName ?? `${userInfo.name} ${userInfo.lastName}`;
  const userName = `${displayName} (${ROLES_MAP[activeRole]})`;

  return (
    <div className="flex items-center justify-between bg-yellow-100 px-4 py-2 dark:bg-yellow-950/50">
      <div className="flex items-center gap-2">
        <UserCog2 className="size-5 text-yellow-700 dark:text-yellow-300" />
        <span className="text-sm text-yellow-700 dark:text-yellow-300">
          Vous êtes actuellement en train de visualiser le compte de {userName}
        </span>
      </div>
      <Button
        variant="outline"
        size="sm"
        className="border-yellow-700 text-yellow-700 hover:bg-yellow-200 hover:text-yellow-800 dark:border-yellow-600 dark:text-yellow-300 dark:hover:bg-yellow-900 dark:hover:text-yellow-200"
        onClick={stopImpersonation}
      >
        Retourner à mon compte
      </Button>
    </div>
  );
}
